import i18n from '/@/i18n';
import { messageStackState } from "/@/app/states/messageStackState";
import { resetScrollsOnCalculate } from "/@/app/scrolls";
import { fetchJWT } from "/@/app/Api";


export const formatDate = (date, keepYear) => {
    if (keepYear === undefined) {
        keepYear = true;
    }

	const lang = i18n.resolvedLanguage || i18n.language;
	const locale = lang === 'ru' ? 'ru-RU' : 'en-US';

    let d = new Date(date);
    let options = {
        month: 'long',
        day: 'numeric',
    };
    if (d.year !== new Date().year || keepYear) {
        options['year'] = 'numeric';
    }

    let dateStr = d.toLocaleDateString(locale, options);
    return dateStr.replace(/ г\.$/, '');
}



// Function to get a cookie by name
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function getCSRFToken() {
    return getCookie('csrftoken');
}

export const DjangoCSRFToken = () => {
    return <input type="hidden" value={getCSRFToken()} name="csrfmiddlewaretoken" />
}


export function CustomError(status, message, data) {
    this.status = status;
    this.message = message;
    this.data = data;
}

export function numberOrNull(value) {
    if (typeof value === 'number' && !isNaN(value)) {
        return value;
    }
    return null
}

export function valueOrNull(value) {
    if (value === undefined) {
        return null;
    }
    return value
}

export function isObject(variable) {
    return typeof variable === 'object' && variable !== null;
}

export function sameSite()
{
	let backend_url=window.appConfig.backend_url || window.origin;
	if (!backend_url.endsWith('/')) backend_url+='/';
	let origin=window.origin+'/';
	return backend_url.startsWith(origin);
}

function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
}

function isTokenExpired(token) {
    const payload = parseJwt(token);
    if (!payload || !payload.exp) return true;

    // exp is in seconds since epoch
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
}

function globalError({ title, body }, showFn) {

    let text = showFn?showFn({title:title,body:body}):"" + title + '.\n' + body;
    text = text.replace(/<br>/g, "\n");
    text = text.replace(/<a[^>]*>([^<]+)<\/a>/g, "$1");

    messageStackState.addMessage({text: text, tags: 'error'})
}

export function showGlobalError(status, message, showFn) {
    switch (status) {
        case "unknown":
            globalError({
                title: 'Что-то пошло не так!',
                body: `Please try again.`,
            }, showFn);
            break;
        case 400:
            globalError({
                title: 'Error 400 <br> Form error',
                body: message,
            }, showFn);
            break;
        case 401:
            globalError({
                title: 'Пожалуйста, авторизуйтесь на Nestarenie.Expert. Перезагрузите страницу для авторизации.',
                body: message || "Please try to <a href='/accounts/login/'>log in</a> or <a href='/accounts/signup/'>sign up</a>",
            }, showFn);
            break;
        case 403:
            globalError({
                title: 'Нет доступа. Попробуйте перезагрузить страницу.',
                body: message || "",
            }, showFn);
            break;
        case 404:
            globalError({
                title: 'Ресурс не найден. Попробуйте перезагрузить страницу.',
                body: message || "Item is not found. Please try refreshing the page.",
            }, showFn);
            break;
        case 409:
            globalError({
                title: '409: Невозможно завершить действие. Попробуйте перезагрузить страницу.',
                body: message || "",
            }, showFn);
            break;
        case 422:
            globalError({
                title: 'Ошибка 422: Nestarenie.Expert не может принять эти данные. Попробуйте перезагрузить страницу.',
                body: message || "",
            }, showFn);
            break;
        case 500:
            globalError({
                title: 'Что-то пошло не так! Наши инженеры уже получили отчёт об ошибке. Перезагрузите страницу, и попробуйте ещё раз.',
                body: message || "",
            }, showFn);
            break;
        case 501:
            globalError({
                title: '501: функция пока не реализована.',
                body: message || "",
            }, showFn);
            break;
        case 502:
            globalError({
                title: 'Nestarenie.Expert сейчас обновляется. Подождите минуту, и попробуйте обновить страницу.',
                body: message || "",
            }, showFn);
            break;
        case 504:
            globalError({
                title: 'Сервер долго не отвечал. Перезагрузите страницу и попробуйте ещё раз.',
                body: message || '',
            }, showFn);
            break;
        default:
            globalError({
                title: 'Ошибка ' + status + ". Что-то пошло не так. Перезагрузите страницу и попробуйте ещё раз.",
                body: message || '',
            }, showFn);
    }
}

export function makeid(length)
{
	var result           = '';
	var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var charactersLength = characters.length;
	for ( var i = 0; i < length; i++ )
	{
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	};
	return result;
}
